import moment from 'moment';
import { PendingPaymentsReport } from '../types';
import { RollOverInfo, User } from '../../../types/userType';
import { PendingFeeRecord } from '../PendingFeeReportTable';
import { isEmpty } from 'lodash';

const getFatherDetails = (student: User) =>
  (student?.parents || []).find(
    (parent) => parent.family?.relation === 'FATHER'
  ) || null;

const getStudentType = (
  rollOverInfo: RollOverInfo[],
  academicYear: string
): string =>
  rollOverInfo.find(
    (rollOverBlock) => rollOverBlock.academicYear === academicYear
  )?.isNewAdmission
    ? 'New Admission'
    : 'Existing';

const buildPendingFeeReportData = (
  data: PendingPaymentsReport[]
): PendingFeeRecord[] => {
  let studentFatherMapping: { [key: string]: User | null } = {};
  return data.map((item, index) => {
    if (
      !isEmpty(item.studentDetails) &&
      isEmpty(studentFatherMapping[item.studentDetails.id])
    ) {
      studentFatherMapping[item.studentDetails.id] = getFatherDetails(
        item.studentDetails
      );
    }

    const fatherDetails = isEmpty(item.studentDetails)
      ? null
      : studentFatherMapping[item.studentDetails.id];

    return {
      id: index + 1, // DataGrid row id
      srNo: index + 1,
      enrollmentNo: item.studentDetails?.enrollmentNo,
      studentName: item.studentDetails?.name,
      studentType: getStudentType(
        item.studentDetails?.rollOverInfo || [],
        item.session as string
      ),
      studentStatus: item.studentDetails?.status || '',
      grade: item.grade,
      division: item.division,
      academicYear: item.session,
      fathersName: fatherDetails?.name || '',
      contactNo: fatherDetails?.personalDetails?.contactNo || '',
      feeType: item.particulars,
      feePeriod: item.feePeriod,
      paymentDueDate: moment(item.paymentDueDate).format('DD-MMM-YYYY'),
      amount: item.amount,
      lateFee: item.lateFee,
      bounceCharges: item.chequeBounceFee
    };
  }) as PendingFeeRecord[];
};

export { buildPendingFeeReportData };
